// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".VForm_form_1TYN_{display:grid;row-gap:20px}", ""]);
// Exports
exports.locals = {
	"form": "VForm_form_1TYN_"
};
module.exports = exports;
